// Endorsements inherit `name` from the parent contract at creation; `reference` is their own
// identity, so it wins whenever it is non-empty.
export const getEndorsementDisplayName = (endorsement: { name: string; reference?: string | null }): string =>
  endorsement.reference || endorsement.name;
